module.exports = __webpack_public_path__ + "img/wordpress-development.36112884.webp";